// --- User role ---
export var GlobalRole;
(function (GlobalRole) {
    GlobalRole["ADMIN"] = "ADMIN";
    GlobalRole["USER"] = "USER";
    GlobalRole["LEAD"] = "LEAD";
    GlobalRole["AUDITOR"] = "AUDITOR";
})(GlobalRole || (GlobalRole = {}));
/**
 * ADR-089: principalId внешнего отправителя из пары провайдер+id.
 * Формат — `<provider>:<externalId>` (напр. `tg:450316139`).
 */
export function buildPrincipalId(provider, externalId) {
    return `${provider}:${externalId}`;
}
/**
 * ADR-089: разбор principalId на `provider`/`externalId` — деление по **первому**
 * `:`. Невалидное (нет `:`, пустые части) → `null`.
 */
export function parsePrincipalId(principalId) {
    if (typeof principalId !== 'string')
        return null;
    const idx = principalId.indexOf(':');
    if (idx <= 0 || idx === principalId.length - 1)
        return null;
    const provider = principalId.slice(0, idx);
    const externalId = principalId.slice(idx + 1);
    if (!provider || !externalId)
        return null;
    return { provider, externalId };
}
